import { Component, OnInit, ViewEncapsulation, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformServer } from '@angular/common';

import { SysUser } from '../models/sysuser.model';
import { AgentService } from '../services/agent.service';
import { HeaderService } from '../shared/header.service';
import { Cookie } from '../shared/cookie.service';
import { CurrencyService } from '../shared/currency.service';
import { AppSettings } from '../settings/app.settings';

@Component({
  selector: 'agent',
  styleUrls: [ './agent.component.scss' ],
  templateUrl: './agent.component.html',
  encapsulation: ViewEncapsulation.Emulated
})

export class AgentComponent implements OnInit{
  public isNode:boolean;
  public sysuser:SysUser = new SysUser();
  public isCorrect:boolean = undefined;
  public errorLogin: boolean = false;

  constructor(private agentService:AgentService, private cookie:Cookie, 
    private headerService:HeaderService,public currencyService:CurrencyService, @Inject(PLATFORM_ID) private platformId:Object){}

  ngOnInit(){
  this.isNode = isPlatformServer(this.platformId);
  }

  agentLogin(sysuser:SysUser){
    this.agentService.agentLogin(sysuser).subscribe(data =>{
      this.isCorrect = data["response"]["body"]["logged"]
      if(this.isCorrect){
        this.errorLogin = false;
        let login = data["response"]["body"];
        this.cookie.put("guest_session",data["token"]);

        this.cookie.put("isagent","true");
        this.headerService.isAgent = true;

        this.cookie.put("agent_credit",login["availableCredit"]);
        this.headerService.agentCredit = login["availableCredit"];

        this.cookie.put("currency",login["currencyDTO"]["id"]);
        this.currencyService.setCurrencyStr(login["currencyDTO"]["id"]);
        
        window.location.href = `${AppSettings.BASE_DOMAIN}?utm_source=agent&utm_medium=partner`
      }
    },()=>{
       this.errorLogin = true;
    });
  }

}